import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const DateBasis = iotsUtils.fromList(constants.report.workOverdue.dateBasis.ids);
